function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.09501 6.05911L0.97001 1.93411C0.818212 1.77694 0.734217 1.56644 0.736115 1.34794C0.738014 1.12945 0.825655 0.920435 0.980162 0.765928C1.13467 0.611422 1.34368 0.523781 1.56218 0.521882C1.78067 0.519983 1.99118 0.603979 2.14834 0.755777L6.86251 5.46994C7.01874 5.62622 7.1065 5.83814 7.1065 6.05911C7.1065 6.28008 7.01874 6.492 6.86251 6.64828L2.14834 11.3624C1.99118 11.5142 1.78067 11.5982 1.56218 11.5963C1.34368 11.5944 1.13467 11.5068 0.980162 11.3523C0.825655 11.1978 0.738014 10.9888 0.736115 10.7703C0.734217 10.5518 0.818212 10.3413 0.97001 10.1841L5.09501 6.05911Z",
  fill: "#7B7C7C"
});

function SvgIconDropdown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDropdown);
export default ForwardRef;